import type { MenuItem, ToolAccessName } from '@/types';

import { checkUserToolAccess } from './checkUserToolAccess';

/**
 * Show only menu items the user has permission to access
 */
export function getVisibleMenuItems(menuItems: MenuItem[], userGroups: string[]): MenuItem[] {
    return menuItems.filter(item => hasAccessToPermission(item.permission, userGroups));
}

/**
 * Check if user has access to a specific permission
 */
function hasAccessToPermission(permission: ToolAccessName | 'all' | undefined, userGroups: string[]): boolean {
    // If no permission specified, allow access
    if (!permission) return true;

    // If permission is 'all', allow access
    if (permission === 'all') return true;

    return checkUserToolAccess(userGroups, permission);
}
